import { MarginInfo } from './types';

export const getMarginNumberInString = (numberStr: string, defaultValue = 0) => {
  if (!numberStr || typeof numberStr !== 'string') {
    return defaultValue;
  }

  const parseIntValue = parseInt(numberStr, 10);

  if (isNaN(parseIntValue)) {
    return defaultValue;
  }

  return parseIntValue;
};

/**
 * 计算配置Margin时的容器高度
 * @param marginInfo Margin 配置
 * @returns 计算应该减去到的高度
 */
export const getMarginForHeight = (marginInfo: MarginInfo) => {
  const { margin = '', marginTop = '', marginBottom = '' } = marginInfo || {};

  const marginFormatted = margin === 'auto' ? margin : getMarginNumberInString(margin);
  const marginTopFormatted = getMarginNumberInString(marginTop);
  const marginBottomFormatted = getMarginNumberInString(marginBottom);

  // 如果 margin 四个位置一样或者是 auto
  if (marginFormatted) {
    if (marginFormatted === 'auto') {
      return marginFormatted;
    }
    // 上下两个margin
    return `${marginFormatted * 2}px`;
  }

  // 如果设置了 上 或 下
  if (marginTopFormatted || marginBottomFormatted) {
    return `${marginTopFormatted + marginBottomFormatted}px`;
  }

  return 0;
};

export default {};
